module.exports = __webpack_public_path__ + "static/media/hiper-card.e03f8097.png";